import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styled from './index.module.scss';

type ImgsType = {
    [key: string]: string[];
};

const SectionA6 = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.SectionA6');

    const imgsMap: ImgsType = {
        en: [
            'https://websiteoss.ecoflow.com/upload/image/1748311395183/Status%20Overview_en.png',
            'https://websiteoss.ecoflow.com/upload/image/1748311394785/Al%20Assiatant_en.png',
            'https://websiteoss.ecoflow.com/upload/image/1748311394980/Savings%20Calendar_en.png',
            'https://websiteoss.ecoflow.com/upload/image/1748311394615/Remote%20Control_en.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/image/1748311636340/Status%20Overview_de.png',
            'https://websiteoss.ecoflow.com/upload/image/1748311636587/Al%20Assiatant_de.png',
            'https://websiteoss.ecoflow.com/upload/image/1748311635948/Savings%20Calendar_de.png',
            'https://websiteoss.ecoflow.com/upload/image/1748311636105/Remote%20Control_de.png',
        ],
    };

    const specialTitle = locale === 'us' ? t.rich('title', { sup: (text: any) => <sup>{text}</sup> }) : t('title');

    const imgs = imgsMap[locale] || imgsMap['en'];

    return (
        <div className={styled.SectionA6}>
            <EcoSpace />
            <EcoSectionCommon title={specialTitle} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className="content">
                <div className="item">
                    <EfImg pc={imgs[0]} />
                    <div className="text">{t('tip1')}</div>
                </div>
                <div className="item">
                    <EfImg pc={imgs[1]} />
                    <div className="text">{t('tip2')}</div>
                </div>
                <div className="item">
                    <EfImg pc={imgs[2]} />
                    <div className="text">{t('tip3')}</div>
                </div>
                <div className="item">
                    <EfImg pc={imgs[3]} />
                    <div className="text">{t('tip4')}</div>
                </div>
            </div>
        </div>
    );
};

export default SectionA6;
